import { render } from "./GenresSelector.vue?vue&type=template&id=45abe003"
import script from "./GenresSelector.vue?vue&type=script&lang=js"
export * from "./GenresSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__